export default __webpack_public_path__ + "f956edcbeeefe2e76254d8fc027ed3ce.svg";